<template>
  <div id="ItemList" :style="style">
    <div class="content">
      <div class="nav">
        <div class="sign_up">
          <div class="sign_up_in">
            <div class="search search_0" @click="toSignUp(1)">
              <span>{{ $t('youthRregist') }}</span>
              <img src="../assets/img/sign_arrow.png" />
            </div>
            <div class="search search_1" @click="toSignUp(2)">
              <span>{{ $t('carnivalRregist') }}</span>
              <img src="../assets/img/sign_arrow.png" />
            </div>
            <div class="line"></div>
            <div class="search search_2" @click="toPage('/mediaRegist')">
              <span>{{ $t('mediaRegist') }}</span>
              <img src="../assets/img/sign_arrow.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="con">
        <div class="bottoms">
          <div
            :class="{ navs: true, fontCss: ind == i }"
            style="line-height: 59px"
            @click="navClick(v, i, 0)"
            v-for="(v, i) in list"
            :key="i"
          >
            {{ v.name == '首页' ? $t('home') : v.name }}
            <!-- :style="'background-color:' + $store.state.color + ';'" -->
            <span :class="ind == i ? 'xian activenav' : 'xian'"></span>
            <div
              id="subnav"
              :style="{
                'min-width': $i18n.locale == 'en' ? '20rem' : '10rem',
              }"
              v-if="v.subnav"
            >
              <div
                :class="ind1 == index ? 'navsubnav' : 'navsubnav'"
                @click.stop="navClick3(item, i, index)"
                v-for="(item, index) in v.subnav"
                :key="index"
              >
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rigt">
        <div class="sou" @click="toSearch">
          <div class="souimg">
            <img src="../assets/img/homeimgs/搜索@2xb.png" />
          </div>
          <!-- <span>搜索</span> -->
        </div>
        <span>|</span>
        <!-- <div class="lang">
          <el-select v-model="langValue" class="no-border-select">
            <el-option
              v-for="item in langOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span>|</span>
        </div> -->
        <div class="more">
          <el-select
            v-model="moreValue"
            class="no-border-select arrow_color"
            @change="handleMore"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="festival">
          <el-select
            v-model="festivalValue"
            placeholder="请选择"
            @change="handleSite"
            class="site_select"
          >
            <el-option
              v-for="item in festivalOption"
              :key="item.id"
              :label="item.advTitle || item.siteName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken, getToken, setSiteOne } from '@/assets/api/token.js';
import { getColumnAll } from '@/const';
import { isHttpLink } from '@/utils';
import { fetchBanner } from '@/assets/api';
export default {
  props: {
    ind: {
      type: Number,
      default: 0,
    },
    ind1: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      drawer: false,
      shoplist: [],
      isIndeterminate: false,
      checkAll: false,
      allprice: 0,
      direction: 'rtl',
      style: {},
      style2: {
        background: 'rgba(0, 0, 0, 0.2);',
      },
      list: [],
      token: null,
      value: null,
      cartTotal: null,
      langValue: 'EN',
      moreValue: '☰',
      festivalValue: '选项1',
      langOptions: [
        {
          value: '选项1',
          label: '黄金糕',
        },
      ],
      options: [
        // {
        //   value: '选项1',
        //   label: '黄金糕',
        // },
      ],
      festivalOption: [],
      signUplist: [],
    };
  },

  mounted() {
    // this.$store.state.token
    this.token = this.$store.state.token;
    this.festivalOption = this.$store.state.siteList;
    this.festivalValue = this.$store.state.siteValue;
    this.getColumnList();
    this.getSignUp();
    window.addEventListener('scroll', this.scrollToTop2);
    document.onmousemove = (e) => {
      e = e ? e : window.event;
      // console.log("X:" + e.screenX + "Y:" + e.screenY)
      let scrollToTop = document.documentElement.scrollTop;
      if (e.screenY < 400 && scrollToTop > 350) {
        this.style = {
          // 'background-color': 'rgba(0, 0, 0, 0.3)',

          top: '0px',
          transition: 'all 0.8s',
        };
        this.style2 = {};
      } else {
        if (scrollToTop > 350) {
          this.style = {
            top: '-130px',
            transition: 'all 0.8s',
          };
          this.style2 = {};
        }
      }
    };
  },
  computed: {
    siteList() {
      return this.$store.state.siteList;
    },
  },
  methods: {
    getColumnList() {
      const navObj = getColumnAll();
      this.list = navObj.headNav;
      this.options = navObj.moreTab.tab;
    },
    navClick(v, i, index) {
      let id = '';
      if (v.subnav) {
        v.subnav.map((s) => {
          if (s.accessPath == v.accessPath) {
            id = s.id;
          }
        });
      }
      if (v.accessPath) {
        this.$router.push({
          path: v.accessPath,
          query: {
            cloumnId: id,
          },
        });
        // this.$emit('keep', i)
        document.documentElement.scrollTop = 0;
      }
    },
    navClick3(v, i, index) {
      if (v.accessPath) {
        this.$router.push({
          path: v.accessPath,
          query: {
            cloumnId: v.id,
          },
        });
        this.$emit('keep', index);
        document.documentElement.scrollTop = 0;
      }
    },

    //监听滚动
    scrollToTop2() {
      // console.log(5555)
      let scrollToTop = document.documentElement.scrollTop;
      if (scrollToTop > 200 && scrollToTop < 300) {
        // console.log('进来吗')
      } else if (scrollToTop > 300) {
        // console.log('zheli')
        this.style = {
          top: '-130px',
          transition: 'all 0.3s',
        };
        this.style2 = {};
      } else {
        this.style2 = {};
        this.style = {
          // 'background-color': 'rgba(0, 0, 0, 0.3)',

          top: '0px',
          transition: 'all 0.8s',
        };
      }
    },
    handleSite(value) {
      this.$store.commit('setSiteValue', value);
      this.festivalOption.map((f) => {
        if (f.id == value && f.advTitle) {
          window.location.href = f.chaiAddress;
        }
        return;
      });
      setSiteOne(value);
      this.$store.dispatch('getCloumn').then((res) => {
        this.$emit('fetchData', res);
        this.getColumnList(); //重新获取菜单
        let keywords = '';
        this.siteList.map((s) => {
          if (s.id == value) {
            keywords = s.keywords;

            this.$i18n.locale = keywords.includes('en') ? 'en' : 'zh';
            localStorage.setItem('language', this.$i18n.locale); // 如果需要持久化
          }
        });
      });
    },
    handleMore(value) {
      if (value) {
        this.options.map((o) => {
          if (o.id == value) {
            if (isHttpLink(o.accessPath)) {
              window.location.href = o.accessPath;
            } else {
              this.$router.push({
                path: o.accessPath,
                query: { cloumnId: o.id },
              });
            }
          }
        });
      }
    },
    toSearch() {
      this.$router.push({
        path: '/fullSearch',
      });
    },
    toPage(path) {
      this.$router.push({ path: path });
    },
    getSignUp() {
      let data = {
        current: 1,
        size: 999,
        state: 0,
        typeId: '1951525986393645057', //类型
        siteId: this.$store.state.siteValue,
      };
      fetchBanner(data).then((res) => {
        if (res.code == 200) {
          this.signUplist = res.data.records;
        }
      });
    },
    toSignUp(type) {
      const arr = this.signUplist.filter(
        (s) => !s.chaiAddress.includes('/mediaRegist')
      );
      // 青年竞演报名
      arr.map((a) => {
        if (type == 2) {
          if (a.chaiAddress.includes('/Carnival')) {
            this.$router.push({ path: a.chaiAddress });
          }
        } else {
          window.location.href = a.chaiAddress;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
#ItemList {
  width: 100%;
  color: #1d1d1d;
  font-family: SourceHanSansCN-Normal;
  position: fixed;
  z-index: 9999999999;
  top: 0%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s;
  transition-timing-function: ease-in-out;
  z-index: 99;
  background: #f0f1f2;
  height: 100px;
}

.content {
  width: 100vw;
  height: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 6%;
  box-sizing: border-box;
  .nav {
    width: 660px;
    padding: 20px 0;
    height: 100px;
    box-sizing: border-box;

    .sign_up {
      width: 100%;
      background: rgba(218, 219, 223, 0.45);
      height: 3.75rem;
      border-radius: 30px;
      position: relative;
      .sign_up_in {
        display: flex;
        .search {
          width: 220px;
          height: 3.75rem;
          line-height: 3.75rem;
          border-radius: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            color: #2a2a2a;
            font-size: 1rem;
            flex: 1;
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          img {
            width: 2.75rem;
            height: 2.75rem;
            margin-right: 0.5625rem;
          }
        }
        .search_0 {
          background: rgba(218, 219, 223, 0.45);
          box-shadow: 14px 20px 56px 0px rgba(0, 0, 0, 0.12);
          ::after {
            --mask-bg: linear-gradient(red, red);
            --mask-clip: content-box, padding-box;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 220px;
            height: 60px;
            border-radius: 30px;
            padding: 2px 2px 2px 2px;
            background: linear-gradient(
              274deg,
              rgba(182, 182, 182, 0.5),
              rgba(255, 255, 255, 0.5),
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 0.5),
              rgba(182, 182, 182, 0.5)
            );
            mask-composite: exclude;
            mask-clip: var(--mask-clip);
            mask-image: var(--mask-bg), var(--mask-bg);
            -webkit-mask-image: var(--mask-bg), var(--mask-bg);
            -webkit-mask-clip: var(--mask-clip);
            -webkit-mask-composite: destination-out;
          }
        }

        .search_1 {
          background: none;
          position: relative;
          img {
            display: none;
          }
          &:hover {
            width: 220px;
            height: 3.75rem;
            line-height: 3.75rem;
            background: rgba(218, 219, 223, 0.45);
            box-shadow: 14px 20px 56px 0px rgba(0, 0, 0, 0.12);
            border-radius: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              display: block;
            }
          }
        }
        .search_1:hover::after {
          --mask-bg: linear-gradient(red, red);
          --mask-clip: content-box, padding-box;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 220px;
          height: 60px;
          border-radius: 30px;
          padding: 2px 2px 2px 2px;
          background: linear-gradient(
            274deg,
            rgba(182, 182, 182, 0.5),
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 0.5),
            rgba(182, 182, 182, 0.5)
          );
          mask-composite: exclude;
          mask-clip: var(--mask-clip);
          mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-clip: var(--mask-clip);
          -webkit-mask-composite: destination-out;
        }
        .search_2 {
          background: none;
          position: relative;
          img {
            display: none;
          }
          &:hover {
            width: 220px;
            height: 3.75rem;
            line-height: 3.75rem;
            background: rgba(218, 219, 223, 0.45);
            box-shadow: 14px 20px 56px 0px rgba(0, 0, 0, 0.12);
            border-radius: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              display: block;
            }
          }
        }
        .search_2:hover::after {
          --mask-bg: linear-gradient(red, red);
          --mask-clip: content-box, padding-box;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 220px;
          height: 60px;
          border-radius: 30px;
          padding: 2px 2px 2px 2px;
          background: linear-gradient(
            274deg,
            rgba(182, 182, 182, 0.5),
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 0.5),
            rgba(182, 182, 182, 0.5)
          );
          mask-composite: exclude;
          mask-clip: var(--mask-clip);
          mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-clip: var(--mask-clip);
          -webkit-mask-composite: destination-out;
        }
      }
    }
  }
  .con {
    flex: 1;
    font-size: 1.75rem;
    color: #ffffff;

    .bottoms {
      width: 100%;
      height: 50%;
      display: flex;
      // padding-left: 20%;
      justify-content: space-evenly;
      align-items: center;

      .navs {
        cursor: pointer;
        padding: 0px 2px 0px 2px;
        position: relative;
        text-align: center;
        font-size: 1.25rem;
        font-family: SourceHanSansCN-Normal;
        color: #1d1d1d;

        .xian {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          width: 0;
          height: 2px;
          background: #1d1d1d;
          border-radius: 2px;
          transition: all 0.5s;
        }

        .activenav {
          width: 22px;
        }
        &:hover {
          font-family: SourceHanSansCN-Medium;
        }
      }
      .fontCss {
        font-family: SourceHanSansCN-Medium;
      }
      .navs:hover .xian {
        width: 22px;
      }

      #subnav {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 58px;

        background: rgba(66, 68, 81, 0.5);
        font-size: 18px;
        height: 0px;
        overflow: hidden;
        white-space: nowrap;
        transition: all 0.3s;
        opacity: 0;

        .navsubnav {
          font-size: 18px;
          height: 50px;
          line-height: 50px;
          color: #fff;
          width: 100%;
          padding: 0 0.625rem;
          box-sizing: border-box;
        }

        .navsubnav:hover {
          color: #1d1d1d;
          background: rgba(255, 255, 255, 0.65);
          // font-family: SourceHanSansCN-Medium;
          span {
            color: #1d1d1d;
          }
        }

        .subnavActive {
          color: #1d1d1d;
        }
      }

      .navs:hover #subnav {
        height: auto;
        opacity: 1;
      }

      #subnav:hover {
        height: auto;
        opacity: 1;
      }
    }
  }

  .rigt {
    display: flex;
    width: 255px;
    align-items: center;
    justify-content: space-evenly;
    height: 40px;

    .sou {
      display: flex;
      align-items: center;
      margin-right: 5px;
      cursor: pointer;

      .souimg {
        width: 16px;
        height: 16px;
        margin-right: 5px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      span {
        font-size: 16px;
        font-family: SourceHanSansCN-Normal;
        color: #1d1d1d;
      }
    }
    .lang,
    .more,
    .festival {
      display: flex;
      align-items: center;
    }
    .festival {
    }
  }
}
@media (max-width: 960px) {
  .content {
    padding: 0;
  }
}
::v-deep {
  .no-border-select {
    .el-input__inner {
      width: 70px;
      height: 26px;
      border: none !important;
      background-color: transparent !important;
      color: #1d1d1d;
      font-size: 18px;
    }
    .el-input__icon {
      line-height: 0;
    }
    .el-input__inner:hover {
      border: none !important;
    }
    .el-input__inner:focus {
      border: none !important;
    }
  }
  .arrow_color {
    .el-input .el-select__caret {
      color: #1d1d1d !important;
    }
  }
  .festival {
    .el-input__inner {
      width: 124px;
      height: 26px;
      color: #000;
      border-radius: 2px;
      font-size: 18px;
    }
    .el-input__icon {
      line-height: 0;
    }
  }
  .site_select {
    .el-input.is-focus .el-select__caret,
    .el-input.is-active .el-select__caret {
      transform: rotate(0deg) !important;
    }
    .el-input .el-select__caret::before {
      content: '';
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid#000000;
      position: relative;
      top: -1px;
    }
    .el-input:hover .el-select__caret::before,
    .el-input.is-focus .el-select__caret::before {
      border-top-color: #409eff;
    }
  }
}
</style>
